// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerV_container__2V7Tg"};